import {Component, OnDestroy, OnInit} from '@angular/core';
import {LayoutService} from "../../../shared/services/layout/layout.service";
import {Subscription} from "rxjs/Subscription";
import {LanguageService} from "../../../shared/services/language/language.service";
import {ContactForm} from "../../../shared/eloquent/models/contact-form.model";
import {EloquentManagerService} from "../../../shared/eloquent/providers/eloquent-manager.provider";
import {ConfigService} from "../../../shared/services/config/config.service";
import {ToastService} from "../../../shared/services/toast/toast.service";

@Component({
    selector: 'app-contact',
    templateUrl: './contact.component.html',
    styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit, OnDestroy {

    private languageSubscripton: Subscription;
    public currentLanguage = 'en';
    contactForm = new ContactForm();

    constructor(private layoutService: LayoutService,
                private languageService: LanguageService,
                private eloquentManager: EloquentManagerService,
                private configService: ConfigService,
                private toastService: ToastService) {
        this.layoutService.setTitle('Contact');
    }

    ngOnInit() {
        this.subscribeLanguageEvents();

    }


    ngOnDestroy(): void {
        this.unsubscribeLanguageEvents();

    }

    private subscribeLanguageEvents() {
        this.languageSubscripton = this.languageService.language.subscribe((val) => {
            this.currentLanguage = val;
        });
    }

    private unsubscribeLanguageEvents() {
        this.languageSubscripton.unsubscribe();
    }

    submitContactForm = () => {
        console.log('submit');
        this.contactForm.revalidate();

        if (this.contactForm.form_group.invalid) {
            return false;
        }

        const title = this.currentLanguage == 'tr' ? 'İşlem Yapılıyor' : 'Processing';
        const message = this.currentLanguage == 'tr' ? 'Mesajınız gönderilirken lütfen bekleyin.' : 'Please wait while your message is being sent.';
        this.toastService.info(title, message);

        this.eloquentManager.request('POST', this.configService.get('apiBaseUrl') + this.contactForm.getApiPrefix(), this.contactForm).subscribe((response) => {
            if (response) {
                const title = this.currentLanguage == 'tr' ? 'Gönderildi' : 'Sent';
                const message = this.currentLanguage == 'tr' ? 'Mesajınız başarıyla gönderildi. İlginiz için teşekkür ederiz' : 'Your message is sent successfully. Thank you for your interest.';
                this.toastService.success(title, message);
                this.contactForm.form_group.reset();
            } else {
                const title = this.currentLanguage == 'tr' ? 'Başarısız' : 'Failed';
                const message = this.currentLanguage == 'tr' ? 'Mesajınız gönderilirken bir hata oluştu. Lütfen tekrar deneyin.' : 'There is an error while sending your message. Please try again.';
                this.toastService.error(title, message);
            }
        });
    }
}



// WEBPACK FOOTER //
// /var/www/luvi/frontend/src/app/components/public/contact/contact.component.ts